import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalendar, FiSun, FiTrendingUp } = FiIcons;

const cards = [
  {
    key: 'next',
    icon: FiCalendar,
    title: 'Bis zu den nächsten Ferien',
    suffix: 'Schultage',
    text: 'So wenige Schultage noch – die Vorfreude wächst!'
  },
  {
    key: 'summer',
    icon: FiSun,
    title: 'Bis zu den Sommerferien',
    suffix: 'Schultage',
    text: 'Mit jedem Schultag ein Stück näher am Sommerglück!'
  }
];

function OverviewCards({ nextSchoolDays, summerSchoolDays, monthProgress }) {
  const values = { next: nextSchoolDays, summer: summerSchoolDays };

  return (
    <section className="overview-grid" aria-label="Deine Übersicht">
      {cards.map((card) => (
        <article className="stat-card" key={card.key}>
          <SafeIcon icon={card.icon} className="stat-icon" aria-hidden="true" />
          <h2>{card.title}</h2>
          <p className="stat-value">{values[card.key]}</p>
          <p className="stat-suffix">{card.suffix}</p>
          <p className="stat-copy">{card.text}</p>
        </article>
      ))}

      <article className="stat-card progress-card">
        <SafeIcon icon={FiTrendingUp} className="stat-icon" aria-hidden="true" />
        <h2>Dein Gehaltsfortschritt im Monat</h2>
        <p className="stat-value">{monthProgress} %</p>
        <div
          className="progress-track"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"
          aria-valuenow={monthProgress}
          aria-label={`Monat zu ${monthProgress} Prozent fortgeschritten`}
        >
          <span style={{ width: `${monthProgress}%` }} />
        </div>
        <p className="stat-copy">
          {monthProgress === 100
            ? 'Monatsziel erreicht – großartig!'
            : `Schon ${monthProgress} % erreicht. Morgen wartet bereits das nächste Plus!`}
        </p>
      </article>
    </section>
  );
}

export default OverviewCards;